
export const systemalertstext = {
    id: "Id",
    name: "Nom",
    itemtype: "Type d'équipement",
    itemid: "Id équipement",
    alerttype: "Type d'alerte",
    osgroup: "Entité",
    criticity: "Criticité",
    starttimestamp: "Début de l'alerte",
    endtimestamp: "Fin de l'alerte",
    value: "Valeur",
    comments: "Commentaires",
    acquitment: "Acquittement",
    acquited: "Acquittée",
    closed: "Fermée",
    mailsent: "Mail envoyé",
    yes: "Oui ",
    no: "Non",
    noalerts: "Aucune alerte à afficher",
    delete: "Supprimer",
    deleted: "Alerte supprimée",
    nocomments: "Aucun",
    commentsvar: " commentaire(s)",
    warningacquitment: "Attention, acquitter l'alerte la cachera jusqu'à sa résolution.",
    confirmdelete: "Êtes-vous sûr de vouloir supprimer l'alerte?",
    deletealert: "Suppression de l'alerte",
    hideclosed: "Cacher les alertes fermées ou acquittées"
}
